import React from 'react';

const THERAPEUTIC_AREAS = ['Oncology', 'Cardiovascular', 'CNS', 'Immunology', 'Infectious Disease', 'Rare Disease', 'Other'];
const PHASES = ['I', 'II', 'III', 'IV'];
const VISIT_SCHEDULES = [
  { value: 'short', label: 'Short (4 visits)' },
  { value: 'standard', label: 'Standard (8 visits)' },
  { value: 'long', label: 'Long (12 visits)' },
];
const PRIMARY_ENDPOINTS = ['Biomarker response', 'Survival (OS/PFS)', 'Symptom scale', 'Lab threshold'];

export default function TrialProtocolConfig({ protocol, onChange }) {
  const update = (field, value) => onChange({ ...protocol, [field]: value });
  const updateArm = (idx, field, value) => {
    const arms = protocol.arms.map((a, i) => i === idx ? { ...a, [field]: value } : a);
    onChange({ ...protocol, arms });
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      <div>
        <label htmlFor="therapeutic_area" style={{ display: 'block', marginBottom: 4, fontWeight: 500 }}>
          Therapeutic Area
        </label>
        <select
          id="therapeutic_area"
          value={protocol.therapeutic_area}
          onChange={e => update('therapeutic_area', e.target.value)}
          style={{ width: '100%', padding: '8px', borderRadius: 4, border: '1px solid #ccc' }}
        >
          {THERAPEUTIC_AREAS.map(ta => <option key={ta}>{ta}</option>)}
        </select>
      </div>

      <div>
        <label htmlFor="trial_phase" style={{ display: 'block', marginBottom: 4, fontWeight: 500 }}>
          Trial Phase
        </label>
        <select
          id="trial_phase"
          value={protocol.phase}
          onChange={e => update('phase', e.target.value)}
          style={{ width: '100%', padding: '8px', borderRadius: 4, border: '1px solid #ccc' }}
        >
          {PHASES.map(p => <option key={p} value={p}>{p}</option>)}
        </select>
      </div>

      <div>
        <label htmlFor="visit_schedule" style={{ display: 'block', marginBottom: 4, fontWeight: 500 }}>
          Visit Schedule
        </label>
        <select
          id="visit_schedule"
          value={protocol.visit_schedule}
          onChange={e => update('visit_schedule', e.target.value)}
          style={{ width: '100%', padding: '8px', borderRadius: 4, border: '1px solid #ccc' }}
        >
          {VISIT_SCHEDULES.map(s => <option key={s.value} value={s.value}>{s.label}</option>)}
        </select>
      </div>

      <div>
        <label style={{ display: 'block', marginBottom: 4, fontWeight: 500 }}>Arms</label>
        {protocol.arms.map((arm, idx) => (
          <div key={idx} style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
            <input
              value={arm.label}
              onChange={e => updateArm(idx, 'label', e.target.value)}
              placeholder={`Arm ${arm.arm_id} label`}
              style={{ flex: 1, padding: '8px', borderRadius: 4, border: '1px solid #ccc' }}
            />
          </div>
        ))}
      </div>

      <div>
        <label htmlFor="primary_endpoint" style={{ display: 'block', marginBottom: 4, fontWeight: 500 }}>
          Primary Endpoint
        </label>
        <select
          id="primary_endpoint"
          value={protocol.primary_endpoint}
          onChange={e => update('primary_endpoint', e.target.value)}
          style={{ width: '100%', padding: '8px', borderRadius: 4, border: '1px solid #ccc' }}
        >
          {PRIMARY_ENDPOINTS.map(ep => <option key={ep}>{ep}</option>)}
        </select>
      </div>
    </div>
  );
}
